import { InsuranceCarrierEnum } from "./insurance";

export const ACP_ELIGIBLE_INSURERS = [
  InsuranceCarrierEnum.CDPHP,
  InsuranceCarrierEnum.CDPHP_MEDICAID,
  InsuranceCarrierEnum.MVP,
  InsuranceCarrierEnum.MVP_HEALTHCARE,
  InsuranceCarrierEnum.MVP_MEDICAID,
  InsuranceCarrierEnum.MVP_MEDICARE,
  InsuranceCarrierEnum.OTHER,
] as const;
